export default __webpack_public_path__ + "static/media/japreece_name.aaf3b6de.png";